<template>
  <elsa-tree
    accordion
    icon-class="tree-icon"
    :data="treeData"
    :selected-items="selectedItems"
    v-on:node-click="handleNodeClick"
    v-on:add-remove="handleAddRemove"
  >
    <template v-slot:title="{ node }">
      <span v-bind:class="node.data.options.titleClassArray">
        {{ getTitleByLevel(node) }}
      </span>
    </template>
    <template v-slot:tags="{ node }">
      <span class="tag">{{ node.data.difficulty_level }}</span>
    </template>
  </elsa-tree>
</template>

<script>
import ElsaTree from "@/components/common/Tree";
import find from "ramda/src/find";
import propEq from "ramda/src/propEq";
import { getGameTypeIcon } from "@/constants/homework";

export default {
  components: {
    ElsaTree,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    lessonSelected: {
      type: Array,
      default: () => [],
    },
    currentStep: {
      type: Number,
      default: 1,
    },
    loading: { type: Boolean, default: true },
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label",
      },
      expanded: {},
      treeData: [],
      count: 0,
      isExpand: true,
      unitSelected: [],
    };
  },
  mounted() {
    this.parseData();
  },
  computed: {
    selectedItems() {
      return {
        "level-1": this.unitSelected,
        "level-2": this.lessonSelected,
      };
    },
    bookUnits() {
      return Object.keys(this.data).length === 0 ? [] : this.data.modules;
    },
  },
  watch: {
    bookUnits: {
      deep: true,
      handler() {
        this.parseData();
      },
    },
    data: {
      handler() {
        this.parseData();
      },
      deep: true,
    },
  },
  methods: {
    parseData() {
      const tree = [];
      let order = 1;
      this.bookUnits.map(unit => {
        const root = {
          id: unit.id,
          label: unit.name,
          original_id: unit.original_id,
          children: [],
          order: order,
          children_original_id: [],
          options: {
            titleClassArray: ["root-title"],
            showListAction: true,
            addActionText: this.$t("homework.assignment_skill.add_all_to_assignment"),
            removeActionText: this.$t("homework.assignment_skill.remove_all_from_assignment"),
          },
        };
        if (unit.lessons) {
          unit.lessons.map(lesson => {
            const childNode = {
              id: lesson.id,
              label: `${lesson.name} - ${lesson.title}`,
              children: [],
              difficulty_level: lesson.difficulty_level,
              game_type: lesson.game_type,
              original_id: lesson.original_id,
              original_order: lesson.order,
              options: {
                showListAction: true,
                showTags: true,
                showIcon: true,
                iconClassArray: [getGameTypeIcon(lesson.game_type), "game-type"],
                titleClassArray: ["level-2-title"],
              },
            };
            root.children.push(childNode);
            root.children_original_id.push(lesson.original_id);
          });
        }
        tree.push(root);
        order++;
      });
      this.treeData = tree;
      // this.count = ids.length;
    },

    handleNodeClick(data, node) {
      const unit = find(propEq("original_id", data.original_id))(this.bookUnits);
      this.expanded = unit;
    },
    async addRemoveLesson(lesson, parent) {
      if (!this.lessonSelected.includes(lesson.original_id)) {
        await this.$emit("add-lesson", [lesson.original_id]);
        let is_subset = !parent.children_original_id.some(val => this.lessonSelected.indexOf(val) === -1);
        if (is_subset) await this.unitSelected.push(parent.original_id);
      } else {
        await this.$emit("remove-lesson", [lesson.original_id]);
        let is_subset = !parent.children_original_id.some(val => this.lessonSelected.indexOf(val) === -1);
        if (!is_subset) await this.unitSelected.splice(this.unitSelected.indexOf(parent.original_id), 1);
      }
    },
    addRemoveUnit(unit) {
      if (!this.unitSelected.includes(unit.original_id)) {
        this.$emit("add-lesson", unit.children_original_id);
        this.unitSelected.push(unit.original_id);
      } else {
        this.$emit("remove-lesson", unit.children_original_id);
        this.unitSelected = this.unitSelected.filter(id => id !== unit.original_id);
      }
    },
    handleAddRemove(node) {
      if (node.level === 2) this.addRemoveLesson(node.data, node.parent.data);
      else this.addRemoveUnit(node.data);
    },
    getTitleByLevel(node) {
      let prefix = "";
      if (node.level === 1) prefix = this.$t("homework.assignment_skill.unit_title", [node.data.order]);
      return prefix + node.data.label;
    },
    setLesson() {
      this.$emit("next-step", this.currentStep);
    },
  },
};
</script>

<style lang="scss" scoped>
.root-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  /*text-transform: capitalize;*/
  letter-spacing: 0.25px;
  color: #121131;
  font-family: sf-pro-text, sans-serif;
}
.level-1-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #121131;
}

.level-2-title {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
}
</style>
